<script lang="ts">
	import {
		BaseCartesianChart,
		CartesianChartFromType,
		LineChart,
		PieChart,
		type ChartDataInterface,
	} from '@Shelly/shelly-design-system';
	import LayerChartSpacing from './LayerChartSpacing.svelte';

	export let chartData: ChartDataInterface;
	export let thumbMode = false;
	export let legend: boolean | undefined;
	export let fullScreen = false;
	export let showPieLegend = !thumbMode;
	export let pieCenterLabel = 'Total';

	type TemperatureColorSchema = 'red' | 'blue' | undefined;

	const getTemperatureColors = (
		chartData: ChartDataInterface,
	): { colorSchema: TemperatureColorSchema; colorScheme: string[] | undefined } => {
		const seriesStyle = chartData.series?.[0]?.style;
		if (seriesStyle === 'tempSchedule_heat') {
			return { colorSchema: 'red', colorScheme: ['#ff4e60'] };
		}
		if (seriesStyle === 'tempSchedule_cool') {
			return { colorSchema: 'blue', colorScheme: ['#248def'] };
		}
		return { colorSchema: undefined, colorScheme: undefined };
	};
	const isZeroConsumptionChart = (chartData: ChartDataInterface) => {
		if (!/consumption/i.test(chartData.name)) return false;

		const points = chartData.series
			.filter((series) => series.visible !== false)
			.flatMap((series) => series.data || []);
		return points.length > 0 && points.every((point) => Number(point.value ?? 0) === 0);
	};

	$: temperatureColors = getTemperatureColors(chartData);
	$: showZeroConsumptionLine = isZeroConsumptionChart(chartData);
</script>

<LayerChartSpacing enabled={!thumbMode && chartData.type !== 'pie'}>
	{#if chartData.type === 'pie'}
		<PieChart {chartData} showLegend={showPieLegend} centerLabel={pieCenterLabel} />
	{:else if /^(tempSchedule|tariffIntervals)$/.test(chartData.name)}
		<BaseCartesianChart
			{chartData}
			mark="area"
			curve="step"
			showPoints={!thumbMode}
			{legend}
			{fullScreen}
			colorSchema={temperatureColors.colorSchema}
			colorScheme={temperatureColors.colorScheme}
		/>
	{:else if showZeroConsumptionLine}
		{#if thumbMode}
			<CartesianChartFromType
				{chartData}
				{thumbMode}
				{legend}
				{fullScreen}
				colorSchema="green"
				colorScheme={['#25b684']}
			/>
		{:else}
			<LineChart
				{chartData}
				showPoints={false}
				{legend}
				{fullScreen}
				colorSchema="green"
				colorScheme={['#25b684']}
			/>
		{/if}
	{:else}
		<CartesianChartFromType {chartData} {thumbMode} {legend} {fullScreen} />
	{/if}
</LayerChartSpacing>
